import { render, staticRenderFns } from "./QuestionCardForRepresentation.vue?vue&type=template&id=419216f2&"
import script from "./QuestionCardForRepresentation.vue?vue&type=script&lang=ts&"
export * from "./QuestionCardForRepresentation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports